var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.68182 4.8181C2.95796 4.8181 3.18182 5.04196 3.18182 5.3181V12.0454C3.18182 12.2101 3.24727 12.3681 3.36377 12.4846C3.48027 12.6011 3.63827 12.6666 3.80303 12.6666H8.33318C8.60933 12.6666 8.83318 12.8904 8.83318 13.1666C8.83318 13.4427 8.60933 13.6666 8.33318 13.6666H3.80303C3.37306 13.6666 2.9607 13.4958 2.65666 13.1917C2.35262 12.8877 2.18182 12.4753 2.18182 12.0454V5.3181C2.18182 5.04196 2.40568 4.8181 2.68182 4.8181ZM11.6515 4.8181C11.9277 4.8181 12.1515 5.04196 12.1515 5.3181V12.0454C12.1515 12.4753 11.9807 12.8877 11.6767 13.1917C11.3726 13.4958 10.9603 13.6666 10.5303 13.6666C10.2542 13.6666 10.0303 13.4427 10.0303 13.1666C10.0303 12.8904 10.2542 12.6666 10.5303 12.6666C10.6951 12.6666 10.8531 12.6011 10.9696 12.4846C11.0861 12.3681 11.1515 12.2101 11.1515 12.0454V5.3181C11.1515 5.04196 11.3754 4.8181 11.6515 4.8181Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 3.07568C0.5 2.79953 0.723858 2.57568 1 2.57568H13.3333C13.6095 2.57568 13.8333 2.79953 13.8333 3.07568C13.8333 3.35182 13.6095 3.57568 13.3333 3.57568H1C0.723858 3.57568 0.5 3.35182 0.5 3.07568Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16667 6.49992C7.44281 6.49992 7.66667 6.72378 7.66667 6.99992V10.3636C7.66667 10.6397 7.44281 10.8636 7.16667 10.8636C6.89052 10.8636 6.66667 10.6397 6.66667 10.3636V6.99992C6.66667 6.72378 6.89052 6.49992 7.16667 6.49992Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92424 6.49992C5.20038 6.49992 5.42424 6.72378 5.42424 6.99992V10.3636C5.42424 10.6397 5.20038 10.8636 4.92424 10.8636C4.6481 10.8636 4.42424 10.6397 4.42424 10.3636V6.99992C4.42424 6.72378 4.6481 6.49992 4.92424 6.49992Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40909 6.49992C9.68523 6.49992 9.90909 6.72378 9.90909 6.99992V10.3636C9.90909 10.6397 9.68523 10.8636 9.40909 10.8636C9.13295 10.8636 8.90909 10.6397 8.90909 10.3636V6.99992C8.90909 6.72378 9.13295 6.49992 9.40909 6.49992Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.42424 0.833252C4.42424 0.55711 4.6481 0.333252 4.92424 0.333252H9.40909C9.68523 0.333252 9.90909 0.55711 9.90909 0.833252V3.07568C9.90909 3.35182 9.68523 3.57568 9.40909 3.57568C9.13295 3.57568 8.90909 3.35182 8.90909 3.07568V1.33325H5.42424V3.07568C5.42424 3.35182 5.20038 3.57568 4.92424 3.57568C4.6481 3.57568 4.42424 3.35182 4.42424 3.07568V0.833252Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackTrash);
export default __webpack_public_path__ + "static/media/blackTrash.61e007ff01a3c95eefddec9248443d91.svg";
export { ForwardRef as ReactComponent };